import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  TextField,
  EditButton,
  TextInput,
  Filter,
} from "react-admin";
import AudioBookCustomInput from "./AudioBookCustomInput";

const AudioBookFilter = (props) => (
  <Filter {...props}>
    <TextInput source="title" alwaysOn/>
    <TextInput source="category_name" alwaysOn/>
  </Filter>
);

export const AudioBookList = props => (
  <List {...props} filters={<AudioBookFilter/>} filter={{is_published: true}}>
    <Datagrid>
      <TextField source="id"/>
      <TextField source="name"/>
      <TextField source="name_vi"/>
      <TextField source="order" label="Order point"/>
      <TextField source="category_name"/>
      <EditButton basePath="/audio-book"/>
    </Datagrid>
  </List>
);

export const AudioBookEdit = props => (
  <Edit {...props}>
    <AudioBookCustomInput/>
  </Edit>
);

export const AudioBookCreate = props => (
  <Create {...props}>
    <AudioBookCustomInput/>
  </Create>
);
